import React from "react";
import { Header } from "../../header";

export default () => {
  return (
    <div className="e-settings-layout">
      <Header title="Disclaimer" showMenu={false}></Header>
      <div className="e-settings-content">
        <p>
          1. We are not a SEBI registered analyst so we do not provide any view
          about the market
        </p>
        <p>
          2. Our strategy generator generates all strategies based on your view.
          We are not responsible for the profit and loses arising out of any of
          the generated strategies
        </p>
        <p>
          3. Data might be delayed up to 20 minutes depending upon our data
          vendor. We are not responsible for any delay in data. After this app
          reaches 10K installs, we will purchase live data plan and there will
          not be any delay
        </p>
        <p>
          4. All the strategies displayed by our generator is for educational
          purpose only. We do not provide advice or tips on buying or selling
          options.
        </p>
        <p>
          5. Trade at your own risk. We are not responsible for any loses
          arising out of trading the option strategies displayed in the app
        </p>
        <p>
          6. Please learn about the <b>impact cost</b>, which may result in more
          profit or loss than values displayed in this app. Brokerages offer
          basket orders, multi-leg orders, etc to reduce the impact cost when
          executing option strategies. We recommend you to check with your
          brokerage firm about the way they provide to reduce the impact cost in
          option trading
        </p>
        <p>
          7. As we are using free data, our vendor imposed a lot of restrictions
          and limitations on us. So it may take upto a minute for showing data.
          After this app reaches 10K installs, we will switch to a fast plan and
          there will not be any restrictions or limitations.
        </p>
        <p>
          8. Our vendor will do maintenance during holidays or outside market
          timings so data may not be available during that time. Once
          maintenance is over everything will work fine.
        </p>
      </div>
    </div>
  );
};
